export default function UndoToolbar({ action, onUndo }) {
  if (!action) return null;

  const count = action.tasks?.length || 0;
  const message = action.type === 'bulk-delete'
    ? `${count} tâche${count > 1 ? 's' : ''} supprimée${count > 1 ? 's' : ''}`
    : <>Tâche supprimée : <strong>{action.task?.title || 'sans titre'}</strong></>;

  return (
    <div className="undo-toolbar">
      <span className="undo-message">{message}</span>
      <button type="button" className="undo-btn" onClick={onUndo}>Annuler</button>
    </div>
  );
}
